/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Defect_Shelf_Err_ConflictInputs */

const vi_defect_shelf_err_conflict = /** @type {(inputs: Defect_Shelf_Err_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kệ hàng lỗi không được đồng thời là kệ hàng hoàn hoặc kệ bán POS.`)
};

/**

* @param {Defect_Shelf_Err_ConflictInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const defect_shelf_err_conflict = /** @type {((inputs?: Defect_Shelf_Err_ConflictInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Defect_Shelf_Err_ConflictInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_defect_shelf_err_conflict(inputs)
});